/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CalendarConnectionIndexResponse } from '../types/CalendarConnectionIndex'

/**
 * GET /calendar-integrations/connections
 * @see backend/nexus/modules/CalendarIntegrations/Http/Controllers/CalendarConnectionController.php CalendarConnectionController::index
 */
export async function calendarConnectionIndex(
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CalendarConnectionIndexResponse>> {
	return axiosInstance.get('/calendar-integrations/connections', config)
}
